import type { Template } from "@/types";

export const PO_02_H1_V1: Template[] = [
{
    id: "po-02-h1v1-01",
    name: "PO 01 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 56, y: 252, width: 495, height: 346, rotation: 0, imageRotation: 0 },
            { id: "2", x: 762, y: 188, width: 303, height: 477, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-02",
    name: "PO 02 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 56, y: 252, width: 495, height: 346, rotation: 0, imageRotation: 0 },
            { id: "2", x: 713, y: 112, width: 398, height: 626, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-03",
    name: "PO 03 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 56, y: 252, width: 495, height: 346, rotation: 0, imageRotation: 0 },
            { id: "2", x: 609, y: 0, width: 609, height: 851, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-04",
    name: "PO 04 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_04.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 213, width: 609, height: 425, rotation: 0, imageRotation: 0 },
            { id: "2", x: 643, y: 0, width: 539, height: 851, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-05",
    name: "PO 05 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_05.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 52, y: 135, width: 755, height: 574, rotation: 0, imageRotation: 0 },
            { id: "2", x: 814, y: 135, width: 352, height: 574, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-06",
    name: "PO 06 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_06.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 118, width: 833, height: 615, rotation: 0, imageRotation: 0 },
            { id: "2", x: 840, y: 119, width: 376, height: 614, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-07",
    name: "PO 07 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_07.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 105, y: 112, width: 398, height: 626, rotation: 0, imageRotation: 0 },
            { id: "2", x: 665, y: 252, width: 495, height: 346, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-08",
    name: "PO 08 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_08.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 609, height: 851, rotation: 0, imageRotation: 0 },
            { id: "2", x: 665, y: 252, width: 495, height: 346, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-09",
    name: "PO 09 - H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_09.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 35, y: 0, width: 539, height: 851, rotation: 0, imageRotation: 0 },
            { id: "2", x: 609, y: 213, width: 609, height: 425, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h1v1-10",
    name: "PO 10- H1V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-01-h1_v1_10.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 153, y: 188, width: 303, height: 477, rotation: 0, imageRotation: 0 },
            { id: "2", x: 665, y: 252, width: 495, height: 346, rotation: 0, imageRotation: 0 }
    ],
}
];